import { Stack } from '@mui/material';
import React, { forwardRef } from 'react';

const RowLayout = forwardRef(({ sx, children }, ref) => {
  return (
    <Stack
      ref={ref}
      sx={{
        width: '100%',
        ...sx
      }}
    >
      {children}
    </Stack>
  );
});

export default RowLayout;
